export default __webpack_public_path__ + "static/media/fileUploading.51717b99.gif";